function cachePageElements() {
	$layout.elements.logo = $("#logoButton");
	$layout.elements.contentWrapper = $("#content-wrapper");
	$layout.elements.body = $(document.body);
}


function sendGATrackingEvent(category, action, label, value) {
    try {
        ga('send', {
            'hitType': 'event',          // Required.
            'eventCategory': category,   // Required.
            'eventAction': action,      // Required.
            'eventLabel': label,
            'eventValue': value

        });
    } catch (e) {
        Raygun.send(e);
    }
}

function findAndFixTables(){
    $(".sfContentBlock table").each(function () {
        //Add the table class
        if (!$(this).hasClass("table")) {
            $(this).addClass("table");
        }

        //Wrap it in responsive
        $(this).wrap("<div class='table-responsive'>");
    });
}

function styleFixes() {
    $(".RadTabStrip", "#content-wrapper").each(function () {
		$(this).find(".rtsLevel, .rtsUL").addClass("theme-background-color");
	});

}


function wireUpPods() {
	//Hide empty pods that have nothing in them, OR just a pod title
	$layout.elements.contentWrapper.find(".pod-wrapper").each(function () {
        //Check to see
        var firstElement = $(this).find(".pod-title").next();
		var count = firstElement.children().length;
		if (count === 0) {
			$(this).closest(".pod-wrapper").addClass("empty");
		} else {
			if (count === 1) {
				var firstItem = firstElement.children().first();
				if (firstItem.hasClass("pod-title")) {
					//THis is the ONLY thing in the pod...so just hide it
					$(this).closest(".pod-wrapper").addClass("empty");
				}
			}
		}

	    //Wire up collapsed pods
		if (!$(this).hasClass("collapsed")) { //Ignore already collapsed
            if ($(this).find(".pod-title a.collapsed").length > 0) {
                $(this).addClass("collapsed");
		    }
		}

	    //Add class to child pod-titles
		$(this).find(".pod-title:not(:first)").each(function () {
		    $(this).addClass("child");
		});
	});
}
